"use strict";

define('model/document',['require','exports','module','./base','../collection/assignments','datakit/util/url'],function (require, exports, module) {
  var Model = require('./base'),
    Assignments = require('../collection/assignments'),
    url = require('datakit/util/url');
  var Document = Model.extend({
    urlRoot: '/rs/api/form/document',
    virtual: {
      displayName: function displayName() {
        return this.get('studyTitle') + ' - ' + this.get('templateType');
      }
    },
    childModels: {
      decision: 'DocumentDecision'
    },
    initialize: function initialize() {
      Model.prototype.initialize.apply(this, arguments);
      if (this.get('assignments') && !(this.get('assignments') instanceof Assignments)) {
        this.set('assignments', new Assignments(this.get('assignments')));
      }
      this.listenTo(this, 'change:assignments', function () {
        if (this.get('assignments') && !(this.get('assignments') instanceof Assignments)) {
          this.set('assignments', new Assignments(this.get('assignments')), {
            silence: true
          });
        }
      });
    },
    fetch: function fetch(options) {
      options = _.extend({}, options, {
        url: url.template(this.urlRoot + '/get/:id', this)
      });
      return Model.prototype.fetch.call(this, options);
    },
    requestChangePolicy: function requestChangePolicy(policy) {
      var urlPath = url.template('/rs/api/form/document/:documentId/policy', {
        documentId: this.get('id')
      });
      return this.request({
        url: urlPath,
        type: 'PUT',
        data: policy.get('name'),
        contentType: 'text/plain'
      });
    }
  }, {
    all: function all(studyId) {
      return this.createCollection('/rs/api/form/document/:studyId').params({
        studyId: studyId
      });
    },
    submissionCountsGroupedBy: function submissionCountsGroupedBy(group, role) {
      return this.createCollection('/rs/api/form/submission/count?group=:group&role=:role').params({
        group: group,
        role: role
      });
    },
    submissions: function submissions(full) {
      return this.createCollection('/rs/api/form/submission/summary?full=:full').params({
        full: !!full
      });
    },
    submissionsByBoard: function submissionsByBoard(boardId) {
      return this.createCollection('/rs/api/form/document/finder/:boardId').params({
        boardId: boardId
      });
    },
    fullExpeditedDocumentsByMeetingId: function fullExpeditedDocumentsByMeetingId(meetingId) {
      return this.createCollection('/rs/api/meeting/fullExpedited/:meetingId').params({
        meetingId: meetingId
      });
    },
    expeditedDocumentsByMeetingId: function expeditedDocumentsByMeetingId(meetingId) {
      return this.createCollection('/rs/api/meeting/expedited/:meetingId').params({
        meetingId: meetingId
      });
    },
    exemptDocumentsByMeetingId: function exemptDocumentsByMeetingId(meetingId) {
      return this.createCollection('/rs/api/meeting/exempt/:meetingId').params({
        meetingId: meetingId
      });
    },
    adminDocumentsByMeetingId: function adminDocumentsByMeetingId(meetingId) {
      return this.createCollection('/rs/api/meeting/administrative/:meetingId').params({
        meetingId: meetingId
      });
    },
    closureDocumentsByMeetingId: function closureDocumentsByMeetingId(meetingId) {
      return this.createCollection('/rs/api/meeting/closure/:meetingId').params({
        meetingId: meetingId
      });
    },
    IN_DRAFT: ['Unsubmitted', 'Reopened'],
    IN_APPROVALS: ['Awaiting Certification', 'Awaiting Org Approval'],
    ORG_APPROVAL: ['Awaiting Org Approval'],
    PRE_REVIEW: ['Under Pre-Review'],
    UNDER_REVIEW: ['Under Review'],
    POST_REVIEW: ['Under Post Review'],
    UNDER_REVIEW_AND_POST_REVIEW: ['Under Review', 'Under Post Review'],
    SUBMISSION: 'Submission',
    RESEARCH_TEAM_ASSIGNMENTS: ['PRINCIPAL_INVESTIGATOR', 'PRIMARY_CONTACT', 'CO_PRINCIPAL_INVESTIGATOR'],
    IN_DRAFT_GROUP: 'inDraft',
    AWAITING_APPROVAL_GROUP: 'awaitingAuthorization',
    PRE_REVIEW_GROUP: 'preReview',
    UNDER_REVIEW_GROUP: 'underReview',
    POST_REVIEW_GROUP: 'postReview',
    WORKFLOW_STATE: 'workflowState',
    REVIEW_TYPE: 'reviewType',
    TEMPLATE_TYPE: 'templateType'
  });
  module.exports = Document;
});

